import swal from 'sweetalert';

(() => {
  const componentId =
    'clinicHospitalInpatientDashboardCurrentPatientsGuaranteeLetterDetailCardsComponent';
  const app = angular.module('app');

  app.component(componentId, {
    templateUrl: require('./guaranteeLetterDetailCards.component.html'),
    controller: [
      'abp.services.app.hospitalPanelServiceRequest',
      '$uibModal',
      '$state',
      'moment',
      'Hms.Services.ServiceType',
      'Hms.InpatientGuaranteeLetters.GuaranteeLetter',
      'expiredGuaranteeLetterFlow',
      controller,
    ],
    controllerAs: 'vm',
    bindings: {
      guaranteeLetters: '=',
      supportContactNumber: '<?',
      dismissGuaranteeLetter: '&',
      refreshFunction: '&',
    },
  });

  function controller(
    hospitalPanelServiceRequestSvc,
    $uibModal,
    $state,
    moment,
    enumServiceType,
    constsGuaranteeLetter,
    expiredGuaranteeLetterFlow
  ) {
    const vm = this;
    vm.loading = 0;
    vm.supportContactNumber =
      _.isNil(vm.supportContactNumber) || vm.supportContactNumber === undefined
        ? abp.setting.get('Hms.General.SpecialistSupportContactNumber')
        : vm.supportContactNumber;

    vm.enums = {};
    vm.enums.serviceType = enumServiceType;

    vm.cancelRequest = cancelRequest;
    vm.checkInEmployee = checkInEmployee;
    vm.showExpiredGuaranteeLetter = showExpiredGuaranteeLetter;
    vm.requestTopUpAddOn = requestTopUpAddOn;
    vm.getDateTimeString = getDateTimeString;

    vm.getCheckInButtonClass = getCheckInButtonClass;
    vm.enableCheckInButton = enableCheckInButton;
    vm.getCheckInTooltip = getCheckInTooltip;

    function cancelRequest(guaranteeLetter) {
      $uibModal
        .open({
          templateUrl: require('../../../common/cancellationModal/cancel.modal.html'),
          controller: 'clinic.views.hospital.common.cancelModal as vm',
          backdrop: 'static',
          size: 'lg',
          resolve: {
            letterRequestType() {
              return guaranteeLetter.serviceRequestType;
            },
            letterStatus() {
              return guaranteeLetter.guaranteeLetterStatus;
            },
          },
        })
        .result.then((cancellationReason) => {
          if (cancellationReason) {
            const input = {
              letterNumber: guaranteeLetter.guaranteeLetterNumber,
              cancellationReason,
            };

            vm.loading += 1;

            hospitalPanelServiceRequestSvc
              .cancelGuaranteeLetterServiceRequest(input)
              .success(() => {
                abp.notify.success('Cancelled');
              })
              .finally(() => {
                vm.loading -= 1;
                vm.refreshFunction();
              });
          }
        });
    }

    function checkInEmployee(guaranteeLetter) {
      // An expired guarantee letter cannot be checked in or rescheduled — offer cancel-and-reapply
      // instead of sending the hospital into a check-in the server will refuse (HM-11144).

      if (expiredGuaranteeLetterFlow.isExpired({
        status: guaranteeLetter.guaranteeLetterStatus,
        checkInExpiryTime: guaranteeLetter.checkInExpiryTime,
      })) {
        showExpiredGuaranteeLetter(guaranteeLetter);
        return;
      }

      // Check inpatient validity period.
      // Starting from 5 days before scheduled admission date.
      if (guaranteeLetter.serviceType === vm.enums.serviceType.Hospitalization.id
        && !verifyInpatientValidityPeriod(guaranteeLetter.scheduledAdmissionTime)) {
        return;
      }

      const today = moment().format('YYYY-MM-DD');
      const scheduledTime = moment(guaranteeLetter.scheduledAdmissionTime).format('YYYY-MM-DD');
      if (!scheduledTime) return;

      if (scheduledTime === today) {
        swal(
          {
            title: App.localize('ConfirmAdmission'),
            text: App.localize('ConfirmAdmissionNarrative'),
            confirmButtonColor: '#1ab394',
            confirmButtonText: App.localize('Yes'),
            cancelButtonText: App.localize('No'),
            showCancelButton: true,
            closeOnConfirm: false,
          },
          (isConfirm) => {
            if (isConfirm) {
              checkIn('', guaranteeLetter);
              vm.refreshFunction();
            }
            swal.close();
          }
        );
      } else {
        $uibModal
          .open({
            templateUrl: require('../../../patient/admission/admission.modal.html'),
            controller: 'clinic.views.hospital.patient.admission as vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
              scheduleDate() {
                return guaranteeLetter.scheduledAdmissionTime;
              },
              expiryDate() {
                return guaranteeLetter.expiryTime;
              },
              letterNumber() {
                return guaranteeLetter.guaranteeLetterNumber;
              },
            },
          })
          .result.then((data) => {
            if (data.isCheckIn) checkIn(data, guaranteeLetter);
            vm.refreshFunction();
          });
      }
    }

    function checkIn(data, guaranteeLetter) {
      vm.loading += 1;
      hospitalPanelServiceRequestSvc
        .checkIn({
          employeeId: guaranteeLetter.employeeId,
          guaranteeLetterNumber: guaranteeLetter.guaranteeLetterNumber,
          serviceType: guaranteeLetter.serviceRequestType,
          remarks: data.reason,
          actualAdmissionDate: data.actualAdmissionDate,
          newAttachments: data.newAttachments,
        })
        .success((success) => {
          if (success.printUrl !== '') {
            abp.notify.info(App.localize('PatientXCheckedIn', guaranteeLetter.patientName));
            window.open(data.printUrl);
            goToTimeline(guaranteeLetter.guaranteeLetterNumber);
          } else {
            if (success.isEarlyCheckIn) abp.notify.info(App.localize('EarlyCheckInRequestSubmitted'));
            else abp.notify.info(App.localize('LateCheckInRequestSubmitted'));
            vm.refreshFunction();
          }
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function requestTopUpAddOn(guaranteeLetter) {
      const modal = $uibModal.open({
        templateUrl: require('../../../../patient/admissionDetails/patientAdmissionTimelineBody/topUpRequestModal/topUpRequestModal.html'),
        controller: 'clinic.views.hospital.topUpRequestModal as vm',
        backdrop: 'static',
        size: 's',
      });
      modal.result.then((requestType) => {
        $state.go('clinic.topUpRequest', {
          requestType,
          letterNumber: guaranteeLetter.guaranteeLetterNumber,
          panelLocationId: guaranteeLetter.panelLocationId,
          requestId: guaranteeLetter.serviceRequestId,
        });
      });
    }

    function goToTimeline(guaranteeLetterNumber) {
      $state.go('clinic.patientAdmissionDetails', {
        letterNumber: guaranteeLetterNumber,
      });
    }

    function getDateTimeString(date, timeZoneId) {
      return App.getDateTimeString(date, timeZoneId);
    }

    function getCheckInState(guaranteeLetter) {
      // Check if admitted but pending approval
      const isPendingApproval =
        (guaranteeLetter.guaranteeLetterStatus === 0 && !guaranteeLetter.isCurrentlyAdmitted)
        || (guaranteeLetter.guaranteeLetterStatus === 1
        && !guaranteeLetter.isCurrentlyAdmitted
        && guaranteeLetter.serviceRequestType === 3
        && guaranteeLetter.isNotAutoApprovedServiceRequest);

      // Check if approved but not admitted
      const isApprovedNotAdmitted = guaranteeLetter.guaranteeLetterState === 1
        && guaranteeLetter.guaranteeLetterStatus === 1
        && !guaranteeLetter.isCurrentlyAdmitted
        && guaranteeLetter.serviceRequestType !== 5
        && guaranteeLetter.serviceRequestType !== 3;

      // Check if within validity period for inpatient
      const isOutsideValidityPeriod =
        guaranteeLetter.guaranteeLetterStatus === 1 
        && guaranteeLetter.serviceType === vm.enums.serviceType.Hospitalization.id
        && guaranteeLetter.scheduledAdmissionTime
        && !verifyInpatientValidityPeriod(guaranteeLetter.scheduledAdmissionTime);

      return {
        isPendingApproval,
        isApprovedNotAdmitted,
        isOutsideValidityPeriod,
        isEnabled: (!isPendingApproval || isApprovedNotAdmitted) && !isOutsideValidityPeriod
      };
    }

    function enableCheckInButton(guaranteeLetter) {
      const state = getCheckInState(guaranteeLetter);
      return state.isPendingApproval || state.isApprovedNotAdmitted;
    }

    function getCheckInButtonClass(guaranteeLetter) {
      const state = getCheckInState(guaranteeLetter);
      return state.isEnabled ? 'btn btn-info btn-sm' : 'btn btn-default btn-sm disabled';
    }

    function getCheckInTooltip(guaranteeLetter) {
      const state = getCheckInState(guaranteeLetter);
      
      if (state.isOutsideValidityPeriod) {
        return App.localize('CheckInRestrictedToScheduledAdmissionWindow');
      }
      
      if (state.isPendingApproval) {
        return App.localize('CheckinAndPrintGlTooltip', vm.supportContactNumber);
      }

      return null;
    }

    function showExpiredGuaranteeLetter(guaranteeLetter) {
      expiredGuaranteeLetterFlow.prompt({
        letterNumber: guaranteeLetter.guaranteeLetterNumber,
        scheduledAdmissionTime: guaranteeLetter.scheduledAdmissionTime,
        reapplyParams: {
          employeeId: guaranteeLetter.employeeId,
          panelLocationId: guaranteeLetter.panelLocationId,
        },
        onCancelled: () => vm.refreshFunction(),
      });
    }

    function verifyInpatientValidityPeriod(scheduledAdmissionTime) {
      const validityPeriodBeforeDays = constsGuaranteeLetter
        .ValidityPeriodBeforeScheduledAdmissionDays;
      const scheduledDate = moment(scheduledAdmissionTime);
      const today = moment();
      const daysAway = scheduledDate.diff(today, 'days');

      return daysAway <= validityPeriodBeforeDays;
    }

  }
})();
